import { Component, Inject, Optional, OnInit, ViewChild, Input, EventEmitter, Output, HostListener, ViewChildren, QueryList, AfterViewInit, AfterViewChecked, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { ComponentesService } from '../componentes.service';
import { MatButton } from '@angular/material/button';

export interface Accion {
	color?: (element: any) => any;
	condicion?: (element: any) => any;
	icon: (element: any) => any;
	handler?: (element: any) => any;
	title?: (element: any) => any;
}

export interface Toggle {
	checked: (element: any) => boolean;
	onChange: (element) => any;
	enabled?: (element: any) => boolean;
	visible?: (element: any) => boolean;
}

export const BASE_URL = '';

/**
 * TODO: Que loading saque offset de tabla para asignar top, bottom, left y right
 */
@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-acciones',
	templateUrl: './acciones.component.html',
	styleUrls: ['./acciones.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class Acciones implements OnInit, AfterViewInit, AfterViewChecked {
	constructor(
		private componentesService: ComponentesService,
	) {  }

	inicializado = false;

	/** Array de acciones (tabla primaria) */
	@Input() acciones: Accion[] = [];

	/** Pemite configurar un toggle o switch como acción */
	@Input() toggle?: Toggle;

	/** Define la cantidad de iconos a mostrar antes de agrupar */
	@Input() maxIconosVisibles ? = 4;

	/** Define el elemento en el cual se aplica una acción (ej. fila de la tabla) */
	@Input() elemento: any;

	ngOnInit() {

	}

	async ngAfterViewInit() {
		await this.ngAfterViewChecked();
		return;
	}

	async ngAfterViewChecked() {
		return;
	}

	init(datos: Accion[]) {
		return new Promise(resolve => {
			this.ngAfterViewInit().then(() => {
				this.acciones = datos;
				resolve();
			});
		});
	}

	estaVacio() {
		return !this.elemento || Object.values(this.elemento).every((item) => item === null);
	}

	get accionesVisibles() {
		let canti = 0;
		if (this.acciones) {
			canti = this.acciones.filter(accion => !accion.condicion || accion.condicion(this.elemento)).length;
		}
		return canti;
	}
}
